import CtaButton from './CtaButton';
import { SITE_DOMAIN } from '../constants/site';
import './About.css';

export default function About() {
  return (
    <section className="section about-section" id="about">
      <div className="container about-inner">
        <div>
          <h2 className="section-title">About Us</h2>
          <p>
            {SITE_DOMAIN} is built to help drivers, fleet operators, and marine users keep navigation accurate.
            Outdated maps can send you down closed roads, miss new highways, or show incorrect marina entries —
            we make updating straightforward.
          </p>
          <p>
            Our team walks you through device compatibility, software setup, download steps, and troubleshooting
            so you can complete your GPS map update with confidence.
          </p>
          <CtaButton className="btn btn-primary">Talk to a Map Specialist</CtaButton>
        </div>
        <ul className="about-stats">
          <li><strong>3</strong><span>Device categories supported</span></li>
          <li><strong>24/7</strong><span>Online guidance resources</span></li>
          <li><strong>100%</strong><span>Focused on map accuracy</span></li>
        </ul>
      </div>
    </section>
  );
}
